<div class="header-user-nav">
    <div class="header-customer-account">
        @if (currentAccount) {
            <span>{{currentAccount.AccountNumber}}&nbsp;&nbsp;|&nbsp;&nbsp;{{currentAccount.Name}}&nbsp;&nbsp;|&nbsp;&nbsp;{{currentAccount.Location}}</span>
        }
    </div>
</div>
